import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Additional Fields Redux States
import {
  CREATE_ADDITIONAL_FIELD,
  GET_ADDITIONAL_FIELDS,
  ACTIVATE_ADDITIONAL_FIELD,
  GET_ADDITIONAL_FIELD,
  EDIT_ADDITIONAL_FIELD,

} from "./actionTypes";
import {
  // createAdditionalField,
  createAdditionalFieldSuccess,
  setAdditionalFields,
  setAdditionalField,
  activateAdditionalFieldSuccess,
  editAdditionalFieldSuccess,
  // setAdditionalFieldsStatus,
  apiError,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getAdditionalFields({ payload: { page, qnt, value, type } }) {
  try {
    const response = yield call(
      axios.get,
      `/additional-fields?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (value && type ? `&${type}=${value}` : "") +
        '&order=DESC'
      }`
    );
    
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setAdditionalFields(response.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* activateAdditionalField({ payload: { id, active } }) {
  try {
    const response = yield call(
      axios.delete,
      `/additional-fields/${id}?active=${active}`,
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(activateAdditionalFieldSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createAdditionalField({ payload: { data } }) {
  try {
    const response = yield call(axios.post, `/additional-fields`, data);
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message;
      yield put(createAdditionalFieldSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getAdditionalField({ payload: { id, isForm } }) {
  try {
    let response;
      response = yield call(
        axios.get,
        `/additional-fields?${
          (isForm ? `form=${isForm}` : "") + (id ? `&id=${id}` : "")
        }`,
        {}
      );

    if (response && (response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setAdditionalField({ data: response.data.data, skills: response.data.data.skills }));
    } else yield put(setAdditionalField({ data: null, skills: null }));
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* editAdditionalField({ payload: { id, values } }) {
  try {
    const response = yield call(
      axios.put,
      `/additional-fields/${id}`,
      values
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editAdditionalFieldSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
// function* deleteTab({ payload: { idTab } }) {
//   try {
//     const response = yield call(
//       axios.delete,
//       `/tab${idTab ? `?id=${idTab}` : ""}`
//     );
//     if (response.status >= 200 || response.status <= 299) {
//       let message = response.data.message ? response.data.message : "";
//       yield put(deleteTabSuccess(message));
//     } else {
//       throw response.data;
//     }
//   } catch (error) {
//     let message;
//     if (error.response && error.response.status) {
//       switch (error.response.status) {
//         case 401:
//           message = "Invalid credentials";
//           break;
//         case 404:
//           message = "Sorry! the page you are looking for could not be found";
//           break;
//         case 500:
//           message =
//             "Sorry! something went wrong, please contact our support team";
//           break;
//         default:
//           if (error.response.data && error.response.data.message)
//             message = error.response.data.message;
//           else message = error.message;
//           break;
//       }
//     }
//     yield put(apiError(message));
//   }
// }
export function* watchAdditionalField() {
  yield takeEvery(GET_ADDITIONAL_FIELDS, getAdditionalFields);
}
export function* watchActivateAdditionalField() {
  yield takeEvery(ACTIVATE_ADDITIONAL_FIELD, activateAdditionalField);
}
export function* watchGetAdditionalField() {
  yield takeEvery(GET_ADDITIONAL_FIELD, getAdditionalField);
}
export function* watchCreateAdditionalField() {
  yield takeEvery(CREATE_ADDITIONAL_FIELD, createAdditionalField);
}
export function* watchEditAdditionalField() {
  yield takeEvery(EDIT_ADDITIONAL_FIELD, editAdditionalField);
}
// export function* watchDeleteTab() {
//   yield takeEvery(DELETE_TAB, deleteTab);
// }
function* authSaga() {
  yield all([
    fork(watchAdditionalField),
    fork(watchActivateAdditionalField),
    fork(watchGetAdditionalField),
    fork(watchCreateAdditionalField),
    fork(watchEditAdditionalField),
    // fork(watchDeleteTab),
  ]);
}

export default authSaga;
